import { PhoneNumberVerificationStatus, User } from '@eppendorf/vnls-user-tenant-utils';
import { SupportedSMSCountries } from '@eppendorf/vnls-utils';

import type { AutocompleteSelectOption } from '$components/autocomplete';

export type PhoneNumbersForm = {
  number?: string;
  countryAndCodeJSONString?: string;
  status?: PhoneNumberVerificationStatus;
};

export type CountryAndCodeParsedFormValue = {
  country: string;
  countryCode: string;
};

export const getSupportedSMSCountriesOptions: () => AutocompleteSelectOption[] = () =>
  SupportedSMSCountries.map(({ country, code }): AutocompleteSelectOption => {
    const plusCountryCode = `+${code}`;

    return {
      label: `${country} (${plusCountryCode})`,
      value: JSON.stringify({
        country,
        countryCode: plusCountryCode,
      } as CountryAndCodeParsedFormValue),
    };
  });

export const getSMSCountry = (countrySelected: string) => {
  if (!countrySelected) {
    return undefined;
  }

  return getSupportedSMSCountriesOptions().find(
    (country) =>
      (JSON.parse(country.value) as CountryAndCodeParsedFormValue).country ===
      (JSON.parse(countrySelected) as CountryAndCodeParsedFormValue).country,
  );
};

export const transformNumbersToForm = (user?: User): PhoneNumbersForm[] => {
  if (user && user.phoneNumbers) {
    const phones: PhoneNumbersForm[] = user.phoneNumbers.map((phone) => ({
      number: phone.number,
      countryAndCodeJSONString: JSON.stringify({
        country: phone.country,
        countryCode: phone.countryCode,
      }),
      status: phone.status,
    }));

    return phones;
  }
  return [];
};
